// Copyright (c) 2016 Deere & Company

import {
    resetCriteria,
    updateDuplicatePinPlateCriteria
} from './criteria';
import {selectAllDealersOnLoad, selectAllDuplicatePinPlateDealers, selectDuplicatePinPlateDealer} from './select-dealer';
import {createDuplicatePinPlateReport} from './create-report';
import {sharedActionCreators} from '../../shared/action-creators';

export default {
    createDuplicatePinPlateReport,
    resetCriteria,
    selectAllDealersOnLoad,
    selectAllDuplicatePinPlateDealers,
    selectDuplicatePinPlateDealer,
    updateDuplicatePinPlateCriteria,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/duplicate-pin-plate/action-creators/index.js